import Confirmation from './Confirmation';
import Position from './Position';
import Region from './Region';
import Service from './Service';
import Shipping from './Shipping';
import Additions from './Additions';
import Summary from './Summary';

export default {
    confirmation: Confirmation,
    position: Position,
    region: Region,
    service: Service,
    shipping: Shipping,
    additions: Additions,
    summary: Summary,
};
